import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df34abb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "aria-label": "Page navigation example" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "page-link",
  "aria-label": "Previous"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-left text-color" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "page-link" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "page-link",
  "aria-label": "Next"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-right text-color" })
], -1))
const _hoisted_7 = [
  _hoisted_6
]

import { ref, watch, watchEffect } from 'vue'
import { useRouter, useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  props: {
  totalPage: {
    type: Number,
    default: 0,
  },
  totalDataOfPage: {
    type: Number,
  },
  isNotFilterUrl: {
    type: Boolean,
    default: false,
  },
  changDelete: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const router = useRouter()
const route = useRoute()

const visiblePages = ref()
const currentPage = ref(1)

const handleSelectPage = (curPage) => {
  currentPage.value = curPage
  if ((curPage == 1 && !route?.query.page) || curPage == route?.query.page) {
    return
  }
  if (props.isNotFilterUrl) {
    return
  }
  if (typeof curPage !== 'number') {
    return
  }
  router.push({ path: route.path, query: { ...route?.query, page: curPage } })
}



const handleNextBackPage = (type) => {
  if (props.isNotFilterUrl) {
    return
  }

  let curPage = Number(route?.query.page) || 1
  let newPage

  if ((curPage >= props.totalPage && type === 'add') || (curPage <= 1 && type === 'sub')) {
    return
  }

  if (type === 'add') {
    newPage = Number(curPage) + 1
  } else {
    newPage = Number(curPage) - 1
  }

  router.push({ path: route.path, query: { ...route?.query, page: newPage } })
}

// const handleStartOrEnd = (type: string) => {
//   if (type === 'start') {
//     router.push({ path: route.path, query: { ...route?.query, page: 1 } })
//     return
//   } else if (type === 'end') {
//     router.push({ path: route.path, query: { ...route?.query, page: props.totalPage } })
//     return
//   }
//   return
// }
const pageChangeDelete = ref(false)
watch(
  () => props.totalPage,
  () => {
    pageChangeDelete.value = true
  }
)

// 2022/09/15 TienNV Delete last item of last page, but not redirect to previous page
watch(
  () => props.totalDataOfPage,
  () => {
    if (props.totalDataOfPage === 0 && Number(route.query?.page) > 1) {
      handleSelectPage(pageChangeDelete.value ? props.totalPage : Number(route.query?.page) - 1)
      return
    }
  }
)

watchEffect(() => {
  if (props.totalDataOfPage === 0 && Number(route.query?.page) > 1 && props.changDelete) {
    handleSelectPage(props.totalPage)
    return
  }
  if (route.query?.page) {
    currentPage.value = Number(route.query?.page)
    return
  }
})

watchEffect(() => {
  if (Number(currentPage.value) <= 7 && Number(props.totalPage) <= 7) {
    visiblePages.value = Array.from({ length: props.totalPage }, (_, i) => i + 1)
    return
  }
  if (Number(currentPage.value) < 5 && Number(props.totalPage) > 7) {
    visiblePages.value = [...Array.from({ length: 5 }, (_, i) => i + 1), '...', props.totalPage - 1, props.totalPage]
    return
  }
  if (Number(currentPage.value) >= 5 && Number(props.totalPage) > 7) {
    if (Number(props.totalPage) - Number(currentPage.value) >= 4) {
      visiblePages.value = [
        1,
        2,
        '...',
        ...Array.from({ length: 3 }, (_, i) => {
          let a = i + Number(currentPage.value) - 2
          return a + 1
        }),
        '...',
        props.totalPage - 1,
        props.totalPage,
      ]
      return
    }
    if (Number(props.totalPage) - Number(currentPage.value) < 4) {
      visiblePages.value = [
        1,
        2,
        '...',
        ...Array.from({ length: 4 }, (_, i) => {
          let a = i + Number(props.totalPage) - 5
          return a + 1
        }),
        Number(props.totalPage),
      ]
      return
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", {
      class: _normalizeClass(['pagination', __props.totalPage <= 1 ? 'prevent-click' : 'cursor-pointer'])
    }, [
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", { disabledButton: Number(_unref(route)?.query.page) <= 1 || __props.totalPage <= 1 || !_unref(route)?.query.page }]),
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleNextBackPage('sub')), ["prevent"]))
      }, _hoisted_3, 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: _normalizeClass(['page-item ', _unref(route)?.query.page === String(page) || (!_unref(route)?.query.page && page === 1) ? 'pageActive' : '']),
          key: index,
          onClick: ($event: any) => (handleSelectPage(page))
        }, [
          _createElementVNode("a", _hoisted_5, _toDisplayString(page), 1)
        ], 10, _hoisted_4))
      }), 128)),
      _createElementVNode("li", {
        class: _normalizeClass(["page-item", { disabledButton: Number(_unref(route)?.query.page) >= Number(__props.totalPage) || __props.totalPage <= 1 }]),
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (handleNextBackPage('add')), ["prevent"]))
      }, _hoisted_7, 2)
    ], 2)
  ]))
}
}

})